module.exports = __webpack_public_path__ + "static_pc/img/wx1.5c6ce576.png";